import { css } from 'react-emotion';
import { getColorByType, fontFamily, heights, colors } from '../../variables';
import { ColorTypes } from '@joykit/variables/colors';
const chroma = require('chroma-js');

const lighten = (color: string) =>
  chroma(color)
    .alpha(0.3)
    .css();

export namespace styles {
  export const label = (type: ColorTypes = 'action') =>
    css({
      fontFamily,
      fontWeight: 100,
      fontSize: 14,
      display: 'inline-block',
      boxSizing: 'border-box',
      color: colors.dark,
      backgroundColor: lighten(getColorByType(type)),
      border: '1px solid',
      borderColor: getColorByType(type),
      borderRadius: 4,
      height: heights.INPUT_HEIGHT - 10,
      minWidth: heights.INPUT_HEIGHT - 10,
      margin: 4,
      padding: '9px 12px',
      cursor: 'pointer'
    });

  export const contentWrapper = css({
    display: 'flex',
    justifyContent: 'space-between'
  });

  export const close = css({
    position: 'relative',
    display: 'inline-block',
    marginLeft: 6,
    top: 3,
    left: 4,
    width: 14,
    height: 14,
    overflow: 'hidden',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      height: '1px',
      width: '100%',
      top: '50%',
      left: 0,
      marginTop: '-1px',
      background: colors.dark
    },
    '&::before': {
      transform: 'rotate(45deg)'
    },
    '&::after': {
      transform: 'rotate(-45deg)'
    }
  });
}
